export function richReplace (text) {
  // eslint-disable-next-line no-useless-escape
  const newsCon = text.replaceAll(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/ig, '<p')
    .replaceAll(/<p/ig, '<p style="font-size: 16Px; line-height: 32Px;"')
    // .replaceAll(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/ig, '<img$1')
    // .replaceAll(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/ig, '<img$1')
    // .replaceAll(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/ig, '<img$1')
    // eslint-disable-next-line no-useless-escape
    .replaceAll(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/ig, '<img$1')
    // .replaceAll(/<img([\s\w"-=\/\.:;]+)/ig, '<img$1 style="max-width: 80%;text-align: center;"')
    .replaceAll(/src="/ig, 'src="')
  return newsCon
}
export function richReplaceNotAll (text) {
  const newsCon = text.replace(/src="/ig, 'src="' + process.env.VUE_APP_BASE_API)
  return newsCon
}



// WEBPACK FOOTER //
// ./src/utils/rich-replace.js